@use 'sass:map';
@use '@helsenorge/designsystem-react/scss/spacers' as spacers;
@use '@helsenorge/designsystem-react/scss/palette' as palette;
@import '@helsenorge/designsystem-react/scss/breakpoints';

$promosection-colors: 'neutral', 'blueberry', 'cherry';
$promosection-onlight-background-color-map: (
  'neutral': var(--brand-color-neutral-verylight),
  'blueberry': var(--brand-color-blueberry-verylight),
  'cherry': var(--brand-color-cherry-verylight),
);
$promosection-onlight-background-hover-color-map: (
  'neutral': palette.$neutral100,
  'blueberry': palette.$blueberry100,
  'cherry': palette.$cherry100,
);
$promosection-ondark-background-color-map: (
  'neutral': palette.$neutral700,
  'blueberry': palette.$blueberry500,
  'cherry': palette.$cherry500,
);
$promosection-ondark-background-hover-color-map: (
  'neutral': palette.$neutral800,
  'blueberry': palette.$blueberry700,
  'cherry': palette.$cherry600,
);
$promosection-border-color-map: (
  'neutral': var(--brand-color-neutral-mediumlight),
  'blueberry': var(--brand-color-blueberry-mediumlight),
  'cherry': var(--brand-color-cherry-mediumlight),
);
$illustration-width-xxs: 228px;
$image-width-md: 241px;

.promosection {
  $promosection: &;

  display: flex;
  flex-direction: column;

  &--cover {
    position: relative;
  }

  &--photo,
  &--illustration {
    &#{$promosection}--medium {
      @media (min-width: map.get($grid-breakpoints, md)) {
        display: grid;
        grid-template-columns: $image-width-md 1fr;
      }

      &#{$promosection}--reverse {
        @media (min-width: map.get($grid-breakpoints, md)) {
          grid-template-columns: 1fr $image-width-md;
        }
      }
    }

    &#{$promosection}--large {
      @media (min-width: map.get($grid-breakpoints, md)) {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
    }
  }

  @each $color in $promosection-colors {
    &--#{$color}-onlight {
      background-color: map.get($promosection-onlight-background-color-map, $color);

      &#{$promosection}--cover {
        &:hover {
          background-color: map.get($promosection-onlight-background-hover-color-map, $color);
        }
      }
    }
    &--#{$color}-ondark {
      color: palette.$white;
      background-color: map.get($promosection-ondark-background-color-map, $color);

      &#{$promosection}--cover {
        &:hover {
          background-color: map.get($promosection-ondark-background-hover-color-map, $color);
        }
      }
    }
    &--#{$color}-onlight#{$promosection}--border,
    &--#{$color}-ondark#{$promosection}--border {
      border: 1px solid map.get($promosection-border-color-map, $color);
    }
  }

  &__image {
    position: relative;
    align-self: center;

    @media (min-width: map.get($grid-breakpoints, md)) {
      align-self: start;
    }

    &--illustration {
      width: $illustration-width-xxs;
      height: $illustration-width-xxs;

      @media (min-width: map.get($grid-breakpoints, md)) {
        justify-self: end;
        width: $image-width-md;
        height: $image-width-md;
      }
    }

    &--photo {
      width: 100%;
      max-width: calc(252px * 2);
      height: 252px;

      @media (min-width: map.get($grid-breakpoints, md)) {
        max-width: fit-content;
        height: 100%;
        max-height: calc($image-width-md * 1.5);
      }
    }

    &--reverse {
      @media (min-width: map.get($grid-breakpoints, md)) {
        order: 2;
        justify-self: end;
      }
    }

    &--mobile-hidden {
      display: none;

      @media (min-width: map.get($grid-breakpoints, md)) {
        display: block;
      }
    }
  }

  &__img {
    display: block;
    width: 100%;
    height: 100%;

    #{$promosection}__image--photo & {
      object-fit: cover;
    }
  }

  &__caption {
    position: absolute;
    right: spacers.getSpacer(2xs);
    bottom: spacers.getSpacer(2xs);
    margin: 0;
    padding: 0 spacers.getSpacer(3xs);
    background: rgb(255 255 255 / 80%);
    font-size: spacers.getSpacer(xs);
    line-height: 130%;
  }

  &__content {
    display: flex;
    flex-direction: column;
    padding: spacers.getSpacer(s);
    gap: spacers.getSpacer(s);

    @media (min-width: map.get($grid-breakpoints, md)) {
      padding-top: spacers.getSpacer(m);
      padding-bottom: spacers.getSpacer(m);
    }

    @media (min-width: map.get($grid-breakpoints, lg)) {
      padding-left: spacers.getSpacer(m);
    }

    &--reduce-padding {
      padding: spacers.getSpacer(s) spacers.getSpacer(2xs);
    }
  }

  &--inset-image {
    gap: spacers.getSpacer(s);
    padding: spacers.getSpacer(xs) spacers.getSpacer(2xs);

    @media (min-width: map.get($grid-breakpoints, md)) {
      gap: spacers.getSpacer(m);
      padding-right: spacers.getSpacer(s);
    }

    #{$promosection}__content {
      padding: 0 0 0 spacers.getSpacer(s);
    }

    &#{$promosection}--photo,
    &#{$promosection}--illustration {
      #{$promosection}__content {
        padding-left: 0;
      }
    }
  }

  &__description,
  &__link-wrapper {
    margin: 0;
  }

  &__link {
    &--title {
      color: inherit;
      text-decoration: none;
      outline: none;

      &:focus {
        box-shadow: 0 0 0 spacers.getSpacer(3xs) currentcolor;
      }
    }

    &--cover {
      &::after {
        inset: 0;
        content: '';
        position: absolute;
      }
    }
  }
}
